import { ServiceCategoryNewInput } from "@me-team/host/main/graphql/types";
import {
    CategoryFormData,
    CategoryRequestInputItem,
} from "../../../interfaces/interfaces";

class RequestInputService {
    public static createServiceCategoryInput = (
        categoryId: number | null,
        subcategoryId: number | null,
        categoryList: CategoryRequestInputItem[]
    ): ServiceCategoryNewInput => {
        if (categoryId && !subcategoryId) {
            const currentCategory = categoryList?.find((categoryItem) => categoryItem?.id === categoryId);

            if (currentCategory) {
                return {
                    comment: currentCategory.comment,
                    parentCategoryId: null,
                    name: currentCategory.name,
                };
            } else {
                return {
                    comment: null,
                    parentCategoryId: null,
                    name: "",
                };
            }
        }

        if (categoryId && subcategoryId) {
            const currentCategory = categoryList?.find((categoryItem) => categoryItem?.id === categoryId);
            if (currentCategory) {
                const currentSubcategory = currentCategory?.childCategories?.find(
                    (subcategoryItem) => subcategoryItem?.id === subcategoryId
                );
                if (currentSubcategory) {
                    return {
                        comment: currentSubcategory.comment,
                        parentCategoryId: currentSubcategory.parentCategory?.id ?? categoryId,
                        name: currentSubcategory.name,
                    };
                } else {
                    return {
                        comment: null,
                        parentCategoryId: categoryId,
                        name: "",
                    };
                }
            }
        }

        return {
            comment: null,
            parentCategoryId: categoryId,
            name: "",
        };
    };

    public static createCategoryInputFromFormData = (
        currentCategoryInput: ServiceCategoryNewInput,
        formData: CategoryFormData,
        isCreate: boolean,
        categoryId: number
    ): ServiceCategoryNewInput => {
        if (isCreate) {
            return {
                name: formData.categoryName,
                comment: formData.description.trim() ? formData.description : null,
                parentCategoryId: currentCategoryInput.parentCategoryId
                    ? currentCategoryInput.parentCategoryId
                    : categoryId,
            };
        }

        return {
            name: formData.categoryName,
            comment: formData.description.trim() ? formData.description : null,
            parentCategoryId: currentCategoryInput.parentCategoryId,
        };
    };
}

export default RequestInputService;
